export default __webpack_public_path__ + "static/media/instruction1.cbe4dbd7.png";